import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "16",
      height: "16",
      x: "2",
      y: "2",
      fill: "#2F7D32",
      rx: "2"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "m8.934 7.313 1.07 1.984 1.07-1.985h1.34l-1.652 2.82L12.457 13h-1.352l-1.101-2.023L8.902 13H7.543l1.7-2.867-1.657-2.82z"
    }, null, -1)
  ])))
}
export default { render: render }